<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "LEADERBOARD.TITLE" | translate }}</div>
</mat-toolbar>

<app-leaderboard></app-leaderboard>
